<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid">
      <div class="div-header">
        <h1>Corporate Profile Page</h1>
      </div>
      <div class="div-contents">
        <form action=" " [formGroup]="corprateForm">
          <div class="col-12 row">
            <div class="row corpate-main-section">
              <div class="col-lg-12 col-md-6 col-sm-12">
                <p class="sub-title">Organisation Details</p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Organisation Name
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Organisation Name "
                      formControlName="organizationName"
                      [ngClass]="{
                        'is-invalid':
                          add.organizationName.touched &&
                          add.organizationName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.organizationName.touched &&
                        add.organizationName.errors
                      "
                    >
                      <span *ngIf="add.organizationName.errors.required"
                        >Organisation Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Year of Incorporation<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <mat-select
                    formControlName="incubatorYearofEstd"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorYearofEstd.touched &&
                        add.incubatorYearofEstd.errors
                    }"
                    #DistrictSelect
                  >
                    <mat-option value="2020">2020</mat-option>
                    <mat-option value="2021">2021</mat-option>
                    <mat-option value="2023">2023</mat-option>
                    <!-- </mat-option> -->
                  </mat-select>
                  <mat-error
                    *ngIf="
                      add.incubatorYearofEstd.touched &&
                      add.incubatorYearofEstd.errors
                    "
                  >
                    <span *ngIf="add.incubatorYearofEstd.errors.required"
                      >Website is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Brief Description of organisation<span
                        class="text-danger"
                        >*</span
                      ></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Brief Description "
                      formControlName="incubatorRegDesc"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorRegDesc.touched &&
                          add.incubatorRegDesc.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorRegDesc.touched &&
                        add.incubatorRegDesc.errors
                      "
                    >
                      <span *ngIf="add.incubatorRegDesc.errors.required"
                        >Brief Description of organisation is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-8 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Head office / Registered Office Address<span
                        class="text-danger"
                        >*</span
                      ></mat-label
                    >
                    <textarea
                      matInput
                      formControlName="incubatorRegAddressLine1"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorRegAddressLine1.touched &&
                          add.incubatorRegAddressLine1.errors
                      }"
                    ></textarea>
                    <mat-error
                      *ngIf="
                        add.incubatorRegAddressLine1.touched &&
                        add.incubatorRegAddressLine1.errors
                      "
                    >
                      <span *ngIf="add.incubatorRegAddressLine1.errors.required"
                        >Office Address is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Website<span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Website "
                      formControlName="incubatorWebsite"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorWebsite.touched &&
                          add.incubatorWebsite.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorWebsite.touched &&
                        add.incubatorWebsite.errors
                      "
                    >
                      <span *ngIf="add.incubatorWebsite.errors.required"
                        >Website is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Country <span class="text-danger">*</span></mat-label
                    >
                    <mat-select
                      formControlName="incubatorOprCountry"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorOprCountry.touched &&
                          add.incubatorOprCountry.errors
                      }"
                    >
                      <mat-option value="india">INDIA</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        add.incubatorOprCountry.touched &&
                        add.incubatorOprCountry.errors
                      "
                    >
                      <span *ngIf="add.incubatorOprCountry.errors.required"
                        >Office Address is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >State <span class="text-danger">*</span></mat-label
                  >
                  <mat-select
                    formControlName="incubatorOprState"
                    [(ngModel)]="selectedState"
                    (selectionChange)="onSelectState(selectedState)"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprState.touched &&
                        add.incubatorOprState.errors
                    }"
                  >
                    <mat-option
                      *ngFor="let list of statevalues"
                      [value]="list.stateName"
                    >
                      {{ list.stateName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      add.incubatorOprState.touched &&
                      add.incubatorOprState.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprState.errors.required"
                      >Office Address is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >District <span class="text-danger">*</span></mat-label
                  >
                  <mat-select
                    formControlName="incubatorDistrict"
                    [(ngModel)]="selectedCity"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorDistrict.touched &&
                        add.incubatorDistrict.errors
                    }"
                    #DistrictSelect
                  >
                    <mat-option *ngFor="let list of cities" [value]="list">{{
                      list
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      add.incubatorDistrict.touched &&
                      add.incubatorDistrict.errors
                    "
                  >
                    <span *ngIf="add.incubatorDistrict.errors.required"
                      >Office Address is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 col-md-6 col-sm-12">
                <p class="sub-title">CEO/MD Details</p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Name of the CEO/MD
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Name of the CEO/MD"
                      formControlName="incubatorName"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorName.touched && add.incubatorName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorName.touched && add.incubatorName.errors
                      "
                    >
                      <span *ngIf="add.incubatorName.errors.required"
                        >CEO/MD Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >E mail ID <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      formControlName="email"
                      [ngClass]="{
                        'is-invalid': add.email.touched && add.email.errors
                      }"
                    />
                    <mat-error *ngIf="add.email.touched && add.email.errors">
                      <span *ngIf="add.email.errors.required"
                        >Email is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Mobile <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      formControlName="phone"
                      [ngClass]="{
                        'is-invalid': add.phone.touched && add.phone.errors
                      }"
                    />
                    <mat-error *ngIf="add.phone.touched && add.phone.errors">
                      <span *ngIf="add.phone.errors.required"
                        >Mobile is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-6 col-sm-12">
                <p class="sub-title">SPOC Details</p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >SPOC Name<span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      formControlName="incubatorTeamFirstName"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorTeamFirstName.touched &&
                          add.incubatorTeamFirstName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorTeamFirstName.touched &&
                        add.incubatorTeamFirstName.errors
                      "
                    >
                      <span *ngIf="add.incubatorTeamFirstName.errors.required"
                        >SPOC Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >SPOC Mail ID
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      formControlName="incubatorTeamEmail"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorTeamEmail.touched &&
                          add.incubatorTeamEmail.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorTeamEmail.touched &&
                        add.incubatorTeamEmail.errors
                      "
                    >
                      <span *ngIf="add.incubatorTeamEmail.errors.required"
                        >SPOC Mail ID is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >SPOC Mobile<span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      formControlName="incubatorTeamPhone"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorTeamPhone.touched &&
                          add.incubatorTeamPhone.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubatorTeamPhone.touched &&
                        add.incubatorTeamPhone.errors
                      "
                    >
                      <span *ngIf="add.incubatorTeamPhone.errors.required"
                        >SPOC Mobile is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-6 col-sm-12">
                <p class="sub-title">Additional Details</p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Sectors <span class="text-danger">*</span></mat-label
                    >
                    <mat-select
                      formControlName="subSector"
                      [ngClass]="{
                        'is-invalid':
                          add.subSector.touched && add.subSector.errors
                      }"
                      multiple
                    >
                      <mat-option
                        *ngFor="let subSectors of subSectorValues"
                        [value]="subSectors"
                        >{{ subSectors }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="add.subSector.touched && add.subSector.errors"
                    >
                      <span *ngIf="add.subSector.errors.required"
                        >Sub Sectors is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                    required
                  >
                    <mat-label required
                      >Interested Districts
                      <span class="text-danger">*</span></mat-label
                    >
                    <mat-select
                      formControlName="incubatorOprInterestedDistricts"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorOprInterestedDistricts.touched &&
                          add.incubatorOprInterestedDistricts.errors
                      }"
                    >
                      <mat-option
                        *ngFor="let incubatorDistricts of cities"
                        [value]="incubatorDistricts"
                        >{{ incubatorDistricts }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        add.incubatorOprInterestedDistricts.touched &&
                        add.incubatorOprInterestedDistricts.errors
                      "
                    >
                      <span
                        *ngIf="
                          add.incubatorOprInterestedDistricts.errors.required
                        "
                        >Interested Districts is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-6 col-sm-12">
                <p class="sub-title">Document Details</p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-rows mt-3">
                  <mat-label
                    >Incorporation certificate
                    <span class="text-danger">*</span></mat-label
                  >
                  <label
                    *ngIf="disName != '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ RegdisName }}</span>
                    <input
                      class="d-none"
                      id="input-file-id"
                      type="file"
                      formControlName="documents"
                      (change)="fileRegUpload($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName == '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ RegdisName }}</span>
                    <input
                      class="d-none"
                      id="input-file-id"
                      type="file"
                      (change)="fileRegUpload($event)"
                    />
                  </label>
                  <span class="noti-span"
                    >(Supported Format: png,jpg,jpeg,pdf)
                    <span class="delete-span" *ngIf="disName"
                      ><i
                        class="fas fa-trash delete-i"
                        (click)="deleteImage()"
                        aria-hidden="true"
                      ></i></span
                    ><br />(max file size: 10mb)</span
                  >
                  <mat-error
                    class="font-12"
                    *ngIf="add.documents.touched && add.documents.errors"
                  >
                    <span *ngIf="add.documents.errors.required"
                      >Document is required</span
                    >
                  </mat-error>
                  <div
                    class="text-center mt-2 mb-3"
                    *ngIf="disName == '✔ Uploaded'"
                  >
                    <a
                      class="pdf-btn"
                      href="{{ proFile.documents }}"
                      target="_blank"
                      >View Brochure</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-3 col-sm-12 col-12">
                <div class="text-center form-btn mt-5">
                  <button
                    class="update-btn btn btn-success"
                    color="success"
                    (click)="saveEvent()"
                  >
                    Save
                  </button>
                  <button
                    class="mr-2 btn btn-warning"
                    color="btn-warning"
                    (click)="cancelEvent()"
                  >
                    Cancel</button
                  ><br />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</main>
